const TOKEN_KEY = process.env.VUE_APP_TOKEN_KEY

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  return localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken(token) {
  return localStorage.setItem(TOKEN_KEY, '')
}

export function setAccountCode(code) {
  return localStorage.setItem('ACCOUNT_CODE', code)
}

export function getAccountCode() {
  return localStorage.getItem('ACCOUNT_CODE') || ''
}

export function setTelNumber(tel) {
  localStorage.setItem('TEL_NUMBER', tel || '')
}

export function getTelNumber() {
  return localStorage.getItem('TEL_NUMBER') || ''
}
